export enum ContactsIcons {
  LINKEDIN = 'u_linkedin',
  SKYPE = 'u_skype',
  TELEGRAM = 'u_telegram',
  GITHUB = 'u_github',
  BEHANCE = 'u_behance',
}
